import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Hidden } from '@mui/material'

import cardIcon from "../../images/cardIcon.svg"


const SkillResultCard = ({ name, result, seuil, seuilColor = "rgba(254, 214, 74, 1)" }) => {

  return (
    <Box sx={{
      background:"white",
      border:"1px solid #E7E7E7",
      height:["65px", "70px", "70px", "95px"],
      minHeight:["65px", "70px", "70px", "95px"],
      padding:["10px", "12px", "12px", "20px"],
      display:"flex",
      justifyContent:"space-between",
      gap:["10px", "15px", "15px", "20px"],
      alignItems:"center",
      overflow:"hidden"
    }}>
      <Box sx={{
        display:"flex",
        alignItems:"center",
        gap:["8px", "11px", "11px", "15px"],
        overflow:"hidden"
      }}>
        <Box sx={{
          width:["0px", "40px", "40px", "50px"],
          minWidth:["0px", "40px", "40px", "50px"],
          display:["none", "block"],
          overflow:"hidden",
          aspectRatio:1,
        }}>
          <img src={cardIcon} style={{width:"100%"}}/>
        </Box>
        <Box sx={{
          whiteSpace:"noWrap",
          textOverflow:"ellipsis",
          overflow:"hidden",
          color:"text.black",
          fontSize:["16px", "18px", "18px", "22px"],
          "&:first-letter" : {
            textTransform: "uppercase"
          }
        }}>
          {name}
        </Box>
      </Box>
      <Box sx={{
        display:"flex",
        alignItems:"center",
        gap:["6px", "8px", "8px", "10px"],
        overflow:"hidden",
        flexShrink:0,
      }}>
        {result >= 0 ? (
          <>
            <Hidden smUp>
              <Box sx={{
                display:"flex",
                flexDirection:"column",
                textAlign:"right"
              }}>
                <Box sx={{
                  color:"text.black",
                  fontSize:"17px",
                }}>
                  {result}%
                </Box>
                {seuil >= 0 &&
                  <Box sx={{
                    color:"text.subTitle",
                    fontSize:"12px",
                  }}>
                    Seuil {seuil}%
                  </Box>
                }
              </Box>
              <Box sx={{
                minWidth:"45px",
                minHeight:"20px",
                background:
                  seuil >= 0 ?
                    result >= seuil ?
                      `linear-gradient(90deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) ${seuil}%, ${seuilColor} ${seuil}%, ${seuilColor} ${result}%, rgba(239, 239, 239, 1) ${result}%, rgba(239, 239, 239, 1) 100%)`
                      :
                      `linear-gradient(90deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) ${result}%, rgba(239, 239, 239, 1) ${result}%, rgba(239, 239, 239, 1) 100%)`
                  :
                  `linear-gradient(90deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) ${result}%, rgba(239, 239, 239, 1) ${result}%, rgba(239, 239, 239, 1) 100%)`,
              }}>
              </Box>
            </Hidden>
            <Hidden smDown>
              {seuil >= 0 &&
                <Box sx={{
                  textAlign:"right",
                  color:"text.subTitle",
                  fontSize:["0px", "14px", "14px", "16px"],
                }}>
                  Seuil<br/>
                  {seuil}%
                </Box>
              }
              <Box sx={{
                minWidth:["0px", "175px", "210px", "350px"],
                width:["0px", "175px", "210px", "350px"],
                height:["0px", "40px", "40px", "56px"],
                display:"flex",
                alignItems:"center",
                position:"relative",
              }}>
                <Box sx={{
                  minWidth:"100%",
                  height:["0px", "30px", "30px", "40px"],
                  background:
                    seuil >= 0 ?
                      result >= seuil ?
                        `linear-gradient(90deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) ${seuil}%, ${seuilColor} ${seuil}%, ${seuilColor} ${result}%, rgba(239, 239, 239, 1) ${result}%, rgba(239, 239, 239, 1) 100%)`
                        :
                        `linear-gradient(90deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) ${result}%, rgba(239, 239, 239, 1) ${result}%, rgba(239, 239, 239, 1) 100%)`
                    :
                    `linear-gradient(90deg,rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 1) ${result}%, rgba(239, 239, 239, 1) ${result}%, rgba(239, 239, 239, 1) 100%)`,
                  display:"flex",
                  justifyContent:"center",
                  gap:"calc(100% / 39)",
                }}>
                  {[...Array(19).keys()].map((item, index) => {
                    return (
                      <Box key={index} sx={{
                        background:"white",
                        height:"100%",
                        width:"calc(100% / 39)"
                      }} />
                    )
                  })}
                </Box>
                {seuil >= 0 &&
                  <Box sx={{
                    position:"absolute",
                    top:0,
                    left:seuil+"%",
                    height:"100%",
                    width:["0px", "2px", "2px", "3px"],
                    background:seuilColor,
                  }} />
                }
              </Box>
              <Box sx={{
                color:"text.black",
                fontSize:["0px", "18px", "18px", "24px"],
                minWidth:["0px", "45px", "45px", "60px"],
                textAlign:"right"
              }}>
                {result}%
              </Box>
            </Hidden>
          </>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  )
}

export default SkillResultCard
